import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { useMessage } from '@messageformat/react';

interface Props {
  savingsGraphArray: number[];
  profitGraphArray: number[];
}

const ProfitAndSavingsGraph = (props: Props): JSX.Element => {
  const { savingsGraphArray, profitGraphArray } = props;

  const options = {
    accessibility: {
      description: useMessage('profitAndSavings_altText'),
    },
    chart: {
      marginTop: 25,
    },
    tooltip: {
      enabled: false,
    },
    marker: {
      enabled: false,
    },
    type: 'area',
    credits: { enabled: false },
    navigator: {
      enabled: false,
    },
    rangeSelector: {
      enabled: false,
    },
    scrollbar: { enabled: false },
    plotOptions: {
      series: {
        enableMouseTracking: false,
      },
    },

    yAxis: {
      showLastLabel: true,
      opposite: false,
      gridLineDashStyle: 'Dot',
      gridLineColor: '#778F9B',
      gridLineWidth: 1,
      labels: {
        format: '{value} €',
        style: {
          fontFamily: 'OP Chevin Pro Light',
          fontSize: '15px',
        },
      },
    },
    xAxis: {
      type: 'linear',
      lineColor: '#545454',
      lineWidth: 2,
      tickPositions: [],
      visible: true,
      labels: {
        enabled: false,
      },
    },
    series: [
      {
        type: 'area',
        data: savingsGraphArray,
        dashStyle: 'shortdot',
        lineColor: '#EE5A00',
        color: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [[0, Highcharts.color('#EE5A00').setOpacity(0.2).get('rgba')]],
        },
      },
      {
        type: 'area',
        data: profitGraphArray,
        lineColor: '#EE5A00',
        color: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, Highcharts.color('#EE5A00').setOpacity(0.3).get('rgba')],
            [1, Highcharts.color('#EE5A00').setOpacity(0.0).get('rgba')],
          ],
        },
      },
    ],
  };
  return (
    <div aria-hidden="true">
      <HighchartsReact
        highcharts={Highcharts}
        constructorType="stockChart"
        options={options}
      />
    </div>
  );
};

export default ProfitAndSavingsGraph;
